import type { Step } from "react-joyride";

export const checklistTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຈັດການ Checklist! Checklist ແມ່ນເຄື່ອງມືທີ່ຊ່ວຍຈັດການລາຍການກວດສອບຕ່າງໆ ເພື່ອໃຫ້ການດຳເນີນງານມີຄວາມສອດຄ່ອງ ຄົບຖ້ວນ ແລະມີຄຸນນະພາບ. ທ່ານສາມາດສ້າງ Checklist ສຳລັບການເປີດຮ້ານ, ປິດຮ້ານ, ກວດສອບຄຸນນະພາບ, ຫຼືກິດຈະກຳອື່ນໆ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="checklist-toolbar"]',
    content: "ນີ້ແມ່ນປຸ່ມສ້າງ Checklist ໃໝ່. ກົດປຸ່ມນີ້ເພື່ອເລີ່ມສ້າງ Checklist ທີ່ທ່ານຕ້ອງການ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="checklist-filter"]',
    content:
      "ນີ້ແມ່ນພາກການກອງຂໍ້ມູນ. ທ່ານສາມາດຄົ້ນຫາ Checklist ຕາມຊື່, ປະເພດ, ພະແນກ, ຫຼືສະຖານະ. ກົດປຸ່ມ 'ລ້າງ' ເພື່ອລຶບການກອງທັງໝົດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="checklist-table"]',
    content:
      "ນີ້ແມ່ນຕາຕະລາງສະແດງ Checklist ທັງໝົດ. ທ່ານສາມາດເບິ່ງລາຍລະອຽດ, ແກ້ໄຂ, ຫຼືລຶບ Checklist ໄດ້ຈາກປຸ່ມການກະທໍາທີ່ຢູ່ທາງຂວາແຖວຂອງແຕ່ລະ Checklist.",
    placement: "top",
  },
];
